import React, { useEffect, useRef, useState } from 'react';
import { BuildingStorefrontIcon, PhotoIcon, PhoneIcon, EnvelopeIcon, ChatBubbleOvalLeftEllipsisIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { parseShopPhone, shopWhatsAppUrl } from '../../services/boutiquePhone';

export const SHOP_CATEGORIES = [
  ['Alimentation', 'Alimentation'], ['Vetements', 'Vêtements'], ['Electronique', 'Électronique'],
  ['Beaute', 'Beauté'], ['Maison', 'Maison'], ['Sport', 'Sport'], ['Autre', 'Autre']
];
export const categoryLabel = value => SHOP_CATEGORIES.find(([key]) => key === value)?.[1] || value || 'Boutique';
export const formatShopPrice = value => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Number(value) || 0) + ' FCFA';

export function ShopImage({ src, alt, product = false }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return src && !failed ? <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} /> :
    <span className="shop-image-placeholder">{product ? <PhotoIcon /> : <BuildingStorefrontIcon />}<span>{product ? 'Photo à venir' : 'Votre commerce, à découvrir'}</span></span>;
}

export function ShopContacts({ boutique, message = '' }) {
  const phone = parseShopPhone(boutique.telephone);
  const whatsapp = shopWhatsAppUrl(boutique.telephone, message);
  return <div className="shop-contacts">
    {whatsapp && <a className="shop-button shop-button-whatsapp" href={whatsapp} target="_blank" rel="noopener noreferrer"><ChatBubbleOvalLeftEllipsisIcon />WhatsApp<span className="shop-sr-only"> — {boutique.nom_boutique}</span></a>}
    {phone && <a className="shop-button shop-button-soft" href={'tel:' + phone.number}><PhoneIcon />Appeler<span className="shop-sr-only"> — {boutique.nom_boutique}</span></a>}
    {boutique.email && <a className="shop-button shop-button-soft" href={'mailto:' + boutique.email}><EnvelopeIcon />Email<span className="shop-sr-only"> — {boutique.nom_boutique}</span></a>}
    {boutique.telephone && !phone && <span className="shop-contact-warning">Le vendeur doit compléter son numéro avec un indicatif international.</span>}
  </div>;
}

export function ShopImageDialog({ image, onClose }) {
  const ref = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!image) return undefined;
    const before = document.activeElement, overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.focus();
    const key = event => {
      if (event.key === 'Escape') close.current();
      if (event.key === 'Tab') { event.preventDefault(); ref.current?.focus(); }
    };
    window.addEventListener('keydown', key);
    return () => { document.body.style.overflow = overflow; window.removeEventListener('keydown', key); if (before?.isConnected) before.focus({ preventScroll: true }); };
  }, [image]);
  if (!image) return null;
  return <div className="shop-lightbox" role="dialog" aria-modal="true" aria-label={image.alt || 'Aperçu de la photo'} onClick={onClose}>
    <button ref={ref} type="button" onClick={onClose} aria-label="Fermer la photo"><XMarkIcon /></button>
    <figure onClick={event => event.stopPropagation()}><img src={image.url} alt={image.alt} /><figcaption>{image.alt}</figcaption></figure>
  </div>;
}
